import { render } from "./GetStartedForm.vue?vue&type=template&id=13910d58&scoped=true"
import script from "./GetStartedForm.vue?vue&type=script&lang=js"
export * from "./GetStartedForm.vue?vue&type=script&lang=js"

import "./GetStartedForm.vue?vue&type=style&index=0&id=13910d58&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13910d58"]])

export default __exports__